import { createSlice } from '@reduxjs/toolkit'
import { service } from '../shared/_services/api_service'
import { setLoading } from './loader';
import { errorHandler, successHandler } from '../shared/_helper/responseHelper';

const initialState = {
  examData: [],
  questionData: [],
  examLanguage: 'english'
}

export const ExamSlice = createSlice({
  name: "Exam",
  initialState,
  reducers: {
    setExamData(state, { payload }) {
      state.examData = payload.result
    },
    setQuestionData(state, { payload }) {
      state.questionData = payload
    },
    examLanguageToggle(state, { payload }) {
      state.examLanguage = payload
    }
  }
})

export const { setExamData, setQuestionData, examLanguageToggle } = ExamSlice.actions;

export default ExamSlice.reducer;

export function getExamDetails(id) {
  return async function getExamThunk(dispatch) {
    dispatch(setLoading(true))
    try {
      await service.getExam(id).then(
        (response) => {
          dispatch(setLoading(false))
          dispatch(setExamData(response.data))
        }, (error) => {
          dispatch(setLoading(false))
          errorHandler(error.response)
        }
      );
    } catch (err) {

    }
  }
}
export function getQuestions(userId, lessonId) {
  return async function getQuestionsThunk(dispatch) {
    // dispatch(setLoading(true))
    try {
      await service.getQuestions(userId, lessonId).then(
        (response) => {
          dispatch(setLoading(false))
          dispatch(setQuestionData(response.data))
        }, (error) => {
          dispatch(setLoading(false))
          errorHandler(error.response)
        }
      );
    } catch (err) {

    }
  }
}
export function submitAnswers(data) {
  return async function submitAnswersThunk(dispatch) {
    dispatch(setLoading(true))
    try {
      await service.submitAnswers(data).then(
        (response) => {
          dispatch(setLoading(false))
          // dispatch(setQuestionData(response.data))
        }, (error) => {
          dispatch(setLoading(false))
          // errorHandler(error.response)
        }
      );
    } catch (err) {

    }
  }
}
export function submitTest(body) {
  return async function submitTestThunk(dispatch) {
    dispatch(setLoading(true))
    try {
      await service.submitTest().then(
        (response) => {
          localStorage.clear();
          sessionStorage.clear();
          window.location.replace('/');

          dispatch(setLoading(false))
        }, (error) => {
          dispatch(setLoading(false))
          // errorHandler(error.response)
        }
      );
    } catch (err) {

    }
  }
}



